type Props = {
  addCount: number;
  deleteCount: number;
};

// The staged-change summary shown beside a panel's title: a green +N for pending
// adds and a red -N for pending deletes, mirroring the Users page's at-a-glance
// counts. Renders nothing while a bucket is untouched so a clean panel stays plain.
export default function StagedCountBadges({ addCount, deleteCount }: Props) {
  if (addCount === 0 && deleteCount === 0) return null;

  return (
    <div className="flex flex-row items-center gap-1">
      {addCount > 0 && (
        <span className="badge badge-success font-semibold" title={`${addCount} to add`}>
          +{addCount}
        </span>
      )}
      {deleteCount > 0 && (
        <span className="badge badge-error font-semibold" title={`${deleteCount} to remove`}>
          -{deleteCount}
        </span>
      )}
    </div>
  );
}
